import { render, staticRenderFns } from "./ResultsMenu.vue?vue&type=template&id=3566c11d&scoped=true&"
import script from "./ResultsMenu.vue?vue&type=script&lang=js&"
export * from "./ResultsMenu.vue?vue&type=script&lang=js&"
import style0 from "./ResultsMenu.vue?vue&type=style&index=0&id=3566c11d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3566c11d",
  null
  
)

export default component.exports